import { useCallback, useEffect, useState } from "react";
import { api } from "../api";
import type { TelegramSelf } from "../types";

/** Своя привязка к боту — доступна любому вошедшему. */
export function TelegramPage() {
  const [data, setData] = useState<TelegramSelf | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(false);

  const load = useCallback(() => {
    api
      .telegramSelf()
      .then((d) => {
        setData(d);
        setError("");
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(load, [load]);

  // Пока человек ходит в телеграм нажимать «Запустить», подтягиваем статус
  useEffect(() => {
    if (!data || data.user.telegram_linked) return;
    const t = setInterval(load, 4000);
    return () => clearInterval(t);
  }, [data, load]);

  if (loading) {
    return (
      <div className="card">
        <div className="empty">
          <span className="spinner" /> Загружаю…
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Напоминания в телеграме</h1>
          <p>
            Бот пишет за {data?.reminder_lead_minutes ?? 15} мин до начала встречи,
            а также если встречу перенесли или отменили.
          </p>
        </div>
      </div>

      {error && <div className="banner red">{error}</div>}

      {!data?.configured ? (
        <div className="card">
          <div className="empty">
            <h3>Бот не настроен</h3>
            <p>
              Администратору нужно добавить <span className="mono">TELEGRAM_BOT_TOKEN</span>{" "}
              в <span className="mono">.env</span> и перезапустить сервис.
            </p>
          </div>
        </div>
      ) : data.user.telegram_linked ? (
        <div className="card">
          <div className="card-body">
            <div className="banner green-banner">
              <span>✅</span>
              <div>
                <strong>Телеграм подключён</strong>
                {data.user.telegram_username && (
                  <>Аккаунт @{data.user.telegram_username}. </>
                )}
                Напоминания приходят в чат с ботом.
              </div>
            </div>
            <button
              className="danger"
              onClick={() =>
                api
                  .telegramUnlinkSelf()
                  .then(load)
                  .catch((e) => setError(e.message))
              }
            >
              Отключить напоминания
            </button>
            <div className="muted small" style={{ marginTop: 8 }}>
              То же самое можно сделать командой <span className="mono">/stop</span> в чате
              с ботом.
            </div>
          </div>
        </div>
      ) : (
        <div className="card">
          <div className="card-body">
            <h3>Как подключить</h3>
            <ol className="small" style={{ paddingLeft: 20, lineHeight: 1.9 }}>
              <li>Откройте ссылку ниже — телеграм предложит открыть бота.</li>
              <li>
                Нажмите кнопку <strong>«Запустить»</strong> (или{" "}
                <span className="mono">Start</span>).
              </li>
              <li>Бот ответит, что всё готово. Эта страница обновится сама.</li>
            </ol>

            <div className="field" style={{ marginTop: 16 }}>
              <label>Ваша персональная ссылка</label>
              <div className="row" style={{ flexWrap: "nowrap" }}>
                <input readOnly className="mono" value={data.link_url ?? ""} />
                <button
                  className="nowrap"
                  onClick={() => {
                    if (data.link_url) {
                      navigator.clipboard.writeText(data.link_url);
                      setCopied(true);
                    }
                  }}
                >
                  {copied ? "Скопировано" : "Копировать"}
                </button>
              </div>
            </div>

            {data.link_url && (
              <a className="btn btn-primary" href={data.link_url} target="_blank" rel="noreferrer">
                Открыть бота в телеграме
              </a>
            )}

            <div className="banner amber" style={{ marginTop: 16, marginBottom: 0 }}>
              <span>⚠️</span>
              <div>
                Ссылка личная. Кто её откроет, тот и будет получать ваши
                напоминания — не пересылайте её в общие чаты.
              </div>
            </div>

            <div className="row muted small" style={{ marginTop: 14 }}>
              <span className="spinner" /> Жду нажатия «Запустить»…
            </div>
          </div>
        </div>
      )}
    </>
  );
}
